import { render, staticRenderFns } from "./SelectItemWithBtnForm.vue?vue&type=template&id=3e04faa8&scoped=true&"
import script from "./SelectItemWithBtnForm.vue?vue&type=script&lang=js&"
export * from "./SelectItemWithBtnForm.vue?vue&type=script&lang=js&"
import style0 from "./SelectItemWithBtnForm.vue?vue&type=style&index=0&id=3e04faa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e04faa8",
  null
  
)

export default component.exports